/** Keep the brown requested treatment exclusive to the repair workspace. */
export function repairRequestedClass(workspace: string, status: string): string {
  return workspace === "repair" && status === "依頼済み" ? " repair-requested" : "";
}
